import { Button } from '@pets-ui/Button/Button'
import { ButtonToggleVisiblePassword } from '@pets-ui/ButtonToggleVisiblePassword/ButtonToggleVisiblePassword'
import { HStack } from '@pets-ui/HStack/HStack'
import { ArrowLeftSmall } from '@pets-ui/icons'
import { Input } from '@pets-ui/Input/Input'
import { useWpLayout } from '@pets-ui/useWpLayout/useWpLayout'
import { VStack } from '@pets-ui/VStack/VStack'
import Cookies from 'js-cookie'
import { useState } from 'react'
import { Helmet } from 'react-helmet-async'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom-v5'
import { useRequestSetPassword } from '../../../hooks/apis/wp/useRequestSetPassword'
import { InputVerify } from '../../InputVerify'
import { useContextCosign } from '../../useContextCosign'
import { CardLogin } from '../CardLogin'
import { CardTitleWithIcon } from '../login/CardTitleWithIcon'
import { PasswordSuccessType } from '../login/types'
import { validationPassword } from './validationPassword'

export function PasswordRegister() {
  const { t } = useTranslation()
  const [password, setPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [showPassword, setShowPassword] = useState(false)
  const [showConfirmPassword, setShowConfirmPassword] = useState(false)
  const { passwordErrors, isSame, confirmPasswordError, passwordError } = validationPassword({ password, confirmPassword })
  const history = useHistory()
  const { trigger, isMutating } = useRequestSetPassword()
  const { title } = useContextCosign()
  useWpLayout({ footer: false })

  const handleClickRegisterPassword = async () => {
    try {
      await trigger({ password })
      Cookies.set('password_success', String(PasswordSuccessType.REGISTER))
      history.replace('/password/success')
    }
    catch (e) {
      console.error(e)
    }
  }

  const handleClickBack = () => {
    window.location.href = '/my-account/'
  }

  const hasEmpty = [password, confirmPassword].some(item => item.trim() === '')
  const canSubmit = isSame && !passwordError && !hasEmpty

  return (
    <CardLogin>
      <Helmet>
        <title>
          {t('login.createPassword')}
          {' '}
          -
          {' '}
          {title}
        </title>
      </Helmet>
      <CardTitleWithIcon
        title={t('login.createPassword')}
        leftIcon={<ArrowLeftSmall />}
        onClickLeft={handleClickBack}
      />
      <VStack gap={4}>
        <VStack gap={1}>
          <Input
            value={password}
            onChange={e => setPassword(e.target.value)}
            label={t('login.enterPassword')}
            placeholder={String(t('login.pleaseEnter'))}
            fullWidth
            type={showPassword ? 'text' : 'password'}
            endAdornment={<ButtonToggleVisiblePassword show={showPassword} onClick={() => setShowPassword(!showPassword)} />}
            error={passwordError}
          />
          <HStack gap={3}>
            <InputVerify success={passwordErrors.characters} rule={t('login.leastEightCharacters')} />
            <InputVerify success={passwordErrors.englishLetter} rule={t('login.oneLetter')} />
            <InputVerify success={passwordErrors.numberLetter} rule={t('logib.oneNumber')} />
          </HStack>
        </VStack>
        <VStack gap={1}>
          <Input
            value={confirmPassword}
            onChange={e => setConfirmPassword(e.target.value)}
            label={t('login.confirmPassword')}
            placeholder={String(t('login.reEnterPassword'))}
            fullWidth
            type={showConfirmPassword ? 'text' : 'password'}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                handleClickRegisterPassword()
              }
            }}
            endAdornment={<ButtonToggleVisiblePassword show={showConfirmPassword} onClick={() => setShowConfirmPassword(!showConfirmPassword)} />}
            error={confirmPasswordError}
            helpText={confirmPasswordError ? t('login.passwordsNotMatch') : ''}
          />
        </VStack>
        <Button
          onClick={handleClickRegisterPassword}
          disabled={!canSubmit}
          loading={isMutating}
        >
          {t('login.createPassword')}
        </Button>
      </VStack>
    </CardLogin>
  )
}
